module.exports = __webpack_public_path__ + "img/check.ba1e715f.png";